import styles from "./PaginationList.module.scss";
import { Pagination } from "antd";
import useDeviceCheck from "Hooks/useDeviceCheck";

const PaginationList = ({
  pagination,
  setPagination,
  sizeChanger = true,
  pageSizeOptions = [10, 20, 30, 50, 100],
}) => {
  const { isMobile } = useDeviceCheck();
  const onChange = (newPage, newPageSize) => {
    setPagination({
      ...pagination,
      page: newPage,
      rowsPerPage: newPageSize,
    });
  };
  return (
    <div className={styles["pagination-list"]}>
      <Pagination
        showSizeChanger={sizeChanger}
        onChange={onChange}
        current={pagination.page}
        total={pagination.totalRows}
        pageSize={pagination.rowsPerPage}
        pageSizeOptions={pageSizeOptions}
        simple={isMobile ? { readOnly: true } : false}
      />
    </div>
  );
};

export default PaginationList;
